import io from "socket.io-client";

// grab token once, pass into the handshake for auth
const token = localStorage.getItem("token");
const socket = io(import.meta.env.VITE_API, {
  auth: { token },
});

export default socket;
